<mat-card class="product-card">
  <mat-card-content>
    <nav mat-tab-nav-bar class="navigation-tabs" [tabPanel]="tabPanel">
      <a
        mat-tab-link
        [routerLink]="['./general']"
        routerLinkActive
        #general="routerLinkActive"
        [active]="general.isActive"
      >
        {{ 'labels.heading.General' | translate }}
      </a>
      @for (loanProductDatatable of loanProductDatatables; track loanProductDatatable) {
        <a
          mat-tab-link
          [routerLink]="['./datatables', loanProductDatatable.registeredTableName]"
          routerLinkActive
          #datatable="routerLinkActive"
          [active]="datatable.isActive"
          *LOSxHasPermission="'READ_' + loanProductDatatable.registeredTableName"
        >
          {{ loanProductDatatable.registeredTableName }}
        </a>
      }
    </nav>

    <mat-tab-nav-panel #tabPanel>
      <router-outlet></router-outlet>
    </mat-tab-nav-panel>
  </mat-card-content>
</mat-card>
